import { Fragment, useEffect, useState, useRef } from 'react';
import { RiFolderUserLine } from 'react-icons/ri';
import { VscLoading } from 'react-icons/vsc';
import { connect } from 'react-redux';
import { css } from 'twin.macro';
import { DashStyles } from './styles/DashStyled';
import {
    checkPermission,
    getTeamIdFromURL,
    getChannelIdFromSettingsURL,
    toastWrapper,
    fetchWrapper,
} from '../../../../_helpers';
import { deleteATeamById } from '../../../../_redux/';
import { NavLink } from 'react-router-dom';

import AvatarUserPanel from '../../Common/AvatarUserPanel';
import {
    FaUsers,
    FaRegCalendarAlt,
    FaBook,
    FaChevronLeft,
    FaChevronRight,
    FaPhone,
    FaVideo,
    FaEnvelope,
    FaUserClock,
} from 'react-icons/fa';
import { BsCardChecklist, BsFillPeopleFill } from 'react-icons/bs';
import { TbReportMoney } from 'react-icons/tb';
import { Col, Row } from 'react-bootstrap';
import NavigationBar from '../../../Admin/reusableComponents/NavigationBar';
import EditTeam from '../EditTeam';
import EditChannel from '../EditChannel';
import { getRole } from '../../../../_helpers/roles/get-roles';

import TeamSettingsContent from './TeamSettingsContent';
import { ChannelInfoCard, TeamInfoCard } from './InfoCard';
import EditTeamSettings from '../EditTeamSettings';

const Dash = ({ teams, currUser, goToTeamPage }) => {
    const [visibleEditTeam, setVisibleEditTeam] = useState(false);
    const [visibleDeleteteam, setVisibleDeleteteam] = useState(false);
    const [canViewEVV, setCanViewEVV] = useState(false);

    let teamId = getTeamIdFromURL();
    let team = teams.filter((team) => team.id === teamId);
    const channelIdFromUrl = getChannelIdFromSettingsURL();
    let role = getRole(currUser, team[0]);

    const [channel, setChannel] = useState(currUser?.roomList?.find((room) => room?.id === channelIdFromUrl) || {});

    useEffect(() => {
        if (checkPermission(role, 'update:team', { userId: currUser?.id, teamAdmin: team[0]?.admin })) {
            setVisibleEditTeam(true);
        }
        if (checkPermission(role, 'remove:team', { userId: currUser?.id, teamAdmin: team[0]?.admin })) {
            setVisibleDeleteteam(true);
        }
        if (role === 'admin' || role === 'teamManager' || role === 'owner') {
            setCanViewEVV(true);
        }
    }, [currUser, role, team]);

    useEffect(() => {
        async function getChannelDetails() {
            try {
                const channelObj = await fetchWrapper.get(`/chatrooms/${channelIdFromUrl}`);
                setChannel({ ...channelObj, label: channelObj?.title, value: channelObj?.id, id: channelIdFromUrl });
            } catch (error) {
                if (error.name === 'AbortError') {
                    return;
                }
                toastWrapper.error(error.message);
                window.location.href = '/not-found';
            }
        }
        if (channelIdFromUrl) {
            getChannelDetails();
        }
    }, [channelIdFromUrl]);

    return (
        <DashStyles>
            {team ? (
                <div className="settings-container">
                    <div className="ses-container">
                        <div
                            className="d-flex justify-content-between"
                            css={css`
                                width: 100%;
                            `}
                        >
                            <NavigationBar
                                mainTabName={team[0]?.name}
                                tab1={channel?.title}
                                goToTeamPage={goToTeamPage}
                            />
                            <div
                                className="d-flex"
                                css={css`
                                    height: 40px;
                                `}
                            >
                                {!channelIdFromUrl && visibleEditTeam && team[0] && (
                                    <EditTeam
                                        key="EditTeam-123"
                                        team={team[0]}
                                        visibleDeleteteam={visibleDeleteteam}
                                        goToTeamPage={goToTeamPage}
                                    />
                                )}
                                {!channelIdFromUrl && visibleEditTeam && team[0] && <EditTeamSettings team={team[0]} />}

                                {channelIdFromUrl && team[0] && (
                                    <EditChannel
                                        key="EditChannel-123"
                                        team={team[0]}
                                        teamId={teamId}
                                        room={channel}
                                        visibleDeleteteam={visibleDeleteteam}
                                        goToTeamPage={goToTeamPage}
                                        newChannelSettings={true}
                                        setUpdateChannel={setChannel}
                                    />
                                )}
                            </div>
                        </div>
                        <Row
                            className="team-stats"
                            css={css`
                                align-items: stretch;
                            `}
                        >
                            <Col sm={4} className="px-3">
                                <div
                                    css={css`
                                        box-shadow: none !important;
                                        cursor: default !important;
                                        height: 100%;
                                    `}
                                >
                                    {channelIdFromUrl ? (
                                        <NavLink
                                            css={css`
                                                text-decoration: none !important;
                                                height: 100%;
                                            `}
                                            to={'/'}
                                            exact
                                            activeClassName="selected-card"
                                            className={`settings-cards d-flex flex-column justify-content-center align-items-center`}
                                        >
                                            <ChannelInfoCard team={team} channel={channel} />
                                        </NavLink>
                                    ) : (
                                        <NavLink
                                            css={css`
                                                text-decoration: none !important;
                                                height: 100%;
                                            `}
                                            to={'/'}
                                            exact
                                            activeClassName="selected-card"
                                            className={`settings-cards d-flex flex-column justify-content-center align-items-center`}
                                        >
                                            <div className="info d-flex w-100">
                                                <TeamInfoCard teamData={team[0]} />
                                            </div>
                                        </NavLink>
                                    )}
                                </div>
                            </Col>
                            <Col sm="8">
                                <div
                                    css={css`
                                        display: grid;
                                        grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
                                        gap: 12px;
                                        height: 100%;
                                        align-items: stretch;
                                        @media (max-width: 1400px) {
                                            grid-template-columns: repeat(6, 1fr);
                                        }

                                        @media (max-width: 1200px) {
                                            grid-template-columns: repeat(4, 1fr);
                                        }

                                        @media (max-width: 992px) {
                                            grid-template-columns: repeat(3, 1fr);
                                        }

                                        @media (max-width: 768px) {
                                            grid-template-columns: repeat(4, 1fr);
                                            gap: 8px;
                                        }

                                        @media (max-width: 576px) {
                                            grid-template-columns: repeat(3, 1fr);
                                        }

                                        @media (max-width: 480px) {
                                            grid-template-columns: repeat(2, 1fr);
                                        }
                                    `}
                                >
                                    <NavLink
                                        css={css`
                                            text-decoration: none !important;
                                            height: 100%;
                                        `}
                                        to={'/members/'}
                                        activeClassName="selected-card"
                                        className={`settings-cards d-flex flex-column justify-content-center align-items-center`}
                                    >
                                        <FaUsers size={32} className="text-primary" />
                                        <div className="mt-2" style={{ textAlign: 'center' }}>
                                            Members
                                        </div>
                                    </NavLink>

                                    {!channelIdFromUrl && (
                                        <NavLink
                                            css={css`
                                                text-decoration: none !important;
                                                height: 100%;
                                            `}
                                            to={'/channel/'}
                                            activeClassName="selected-card"
                                            className={`settings-cards d-flex flex-column justify-content-center align-items-center`}
                                        >
                                            <BsFillPeopleFill size={32} className="text-primary" />
                                            <div
                                                className="mt-2"
                                                style={{
                                                    textAlign: 'center',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '2px',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <div>Channels/SMS</div>
                                            </div>
                                        </NavLink>
                                    )}

                                    {((!channelIdFromUrl && team[0]?.provider) ||
                                        (channelIdFromUrl &&
                                            team[0]?.provider &&
                                            channel?.client?.id &&
                                            canViewEVV)) && (
                                        <NavLink
                                            css={css`
                                                text-decoration: none !important;
                                                height: 100%;
                                            `}
                                            to={'/user-evv/'}
                                            activeClassName="selected-card"
                                            className={`settings-cards d-flex flex-column justify-content-center align-items-center`}
                                        >
                                            <BsCardChecklist size={32} className="text-primary" />
                                            <div className="mt-2" style={{ textAlign: 'center' }}>
                                                EVV
                                            </div>
                                        </NavLink>
                                    )}

                                    {((!channelIdFromUrl && team[0]?.provider) ||
                                        (channelIdFromUrl &&
                                            team[0]?.provider &&
                                            channel?.client?.id &&
                                            canViewEVV)) && (
                                        <NavLink
                                            css={css`
                                                text-decoration: none !important;
                                                height: 100%;
                                            `}
                                            to={'/staff-turnover/'}
                                            activeClassName="selected-card"
                                            className={`settings-cards d-flex flex-column justify-content-center align-items-center`}
                                        >
                                            <FaUserClock size={32} className="text-primary" />
                                            <div className="mt-2" style={{ textAlign: 'center' }}>
                                                Staff Turnover
                                            </div>
                                        </NavLink>
                                    )}

                                    {!channelIdFromUrl && team[0]?.provider && (
                                        <NavLink
                                            css={css`
                                                text-decoration: none !important;
                                                height: 100%;
                                            `}
                                            to={'/user-payroll/'}
                                            activeClassName="selected-card"
                                            className={`settings-cards d-flex flex-column justify-content-center align-items-center`}
                                        >
                                            <TbReportMoney size={32} className="text-primary" />
                                            <div className="mt-2" style={{ textAlign: 'center' }}>
                                                Expense
                                            </div>
                                        </NavLink>
                                    )}

                                    <NavLink
                                        css={css`
                                            text-decoration: none !important;
                                            height: 100%;
                                        `}
                                        to={'/form/'}
                                        activeClassName="selected-card"
                                        className={`settings-cards d-flex flex-column justify-content-center align-items-center`}
                                    >
                                        <RiFolderUserLine size={32} className="text-primary" />
                                        <div className="mt-2" style={{ textAlign: 'center' }}>
                                            Documents
                                        </div>
                                    </NavLink>

                                    <NavLink
                                        css={css`
                                            text-decoration: none !important;
                                            height: 100%;
                                        `}
                                        to={'/events/'}
                                        activeClassName="selected-card"
                                        className={`settings-cards d-flex flex-column justify-content-center align-items-center`}
                                    >
                                        <FaRegCalendarAlt size={32} className="text-primary" />
                                        <div className="mt-2" style={{ textAlign: 'center' }}>
                                            Events
                                        </div>
                                    </NavLink>

                                    <NavLink
                                        css={css`
                                            text-decoration: none !important;
                                            height: 100%;
                                        `}
                                        to={'/courses'}
                                        activeClassName="selected-card"
                                        className={`settings-cards d-flex flex-column justify-content-center align-items-center`}
                                    >
                                        <FaBook size={32} className="text-primary" />
                                        <div className="mt-2" style={{ textAlign: 'center' }}>
                                            Courses
                                        </div>
                                    </NavLink>

                                    {!channelIdFromUrl && (
                                        // {!channelIdFromUrl && team[0]?.provider && (
                                        <NavLink
                                            css={css`
                                                text-decoration: none !important;
                                                height: 100%;
                                            `}
                                            to={'/call-center/'}
                                            activeClassName="selected-card"
                                            className={`settings-cards d-flex flex-column justify-content-center align-items-center`}
                                        >
                                            <FaPhone size={32} className="text-primary" />
                                            <div className="mt-2" style={{ textAlign: 'center' }}>
                                                Call Center
                                            </div>
                                        </NavLink>
                                    )}
                                    <NavLink
                                        css={css`
                                            text-decoration: none !important;
                                            height: 100%;
                                        `}
                                        to={'/conference/'}
                                        activeClassName="selected-card"
                                        className={`settings-cards d-flex flex-column justify-content-center align-items-center`}
                                    >
                                        <FaVideo size={32} className="text-primary" />
                                        <div className="mt-2" style={{ textAlign: 'center' }}>
                                            Conference
                                        </div>
                                    </NavLink>
                                    <NavLink
                                        css={css`
                                            text-decoration: none !important;
                                            height: 100%;
                                        `}
                                        to={'/email/'}
                                        activeClassName="selected-card"
                                        className={`settings-cards d-flex flex-column justify-content-center align-items-center`}
                                    >
                                        <FaEnvelope size={32} className="text-primary" />
                                        <div className="mt-2" style={{ textAlign: 'center' }}>
                                            Email
                                        </div>
                                    </NavLink>
                                </div>
                            </Col>
                        </Row>
                        <TeamSettingsContent
                            channelDetails={channel}
                            teamDetails={Array.isArray(team) && team.length ? team[0] : {}}
                        />
                    </div>
                </div>
            ) : (
                <VscLoading className="spin" />
            )}
        </DashStyles>
    );
};

const mapStateToProps = (state) => ({
    teamRooms: state.rooms.teamRooms,
    teams: state.teams.teams,
    currUser: state.user.user,
    organizations: state.organizations.organizations,
});
export default connect(mapStateToProps, { deleteATeamById })(Dash);
